import { render, staticRenderFns } from "./ViewRemessaAric.vue?vue&type=template&id=32e0809e"
import script from "./ViewRemessaAric.vue?vue&type=script&lang=js"
export * from "./ViewRemessaAric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports